// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label__form-name-header[data-v-7f40b768]{font-size:20px;font-weight:700;margin-bottom:1.5rem}@media screen and (max-width:575px){.row__form-input[data-v-7f40b768]{flex-direction:column;gap:1rem}}.text-form_feedback[data-v-7f40b768]{width:100%;margin-top:.25rem;font-size:14px;color:#f83245}", ""]);
// Exports
module.exports = exports;
